// extracted by mini-css-extract-plugin
module.exports = {"container":"_3IKbr","trigger":"_25Pel","curtain":"_2hsU4","popover":"_25PhW","width1":"_2nJPa","width2":"_1qpwY","width3":"_276-M","open":"_383ah"};